import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const StorySection = () => {
  return <section className="py-8 space-y-8" data-id="element-447">
      <FadeIn data-id="element-448">
        <div className="bg-amber-950/40 border border-amber-900/50 rounded-xl p-6 sm:p-8" data-id="element-449">
          <h2 className="text-xl sm:text-2xl font-bold text-amber-500 mb-4 flex items-center gap-2" data-id="element-450">
            <span data-id="element-451">⚠️</span> ATENCIÓN
          </h2>
          <p className="text-lg text-slate-200 font-medium" data-id="element-452">
            Si no haces algo diferente esta noche, mañana será exactamente
            igual.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-453">
        <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-454">
          <p data-id="element-455">
            <strong className="text-white" data-id="element-456">Son las 2:14 AM.</strong> El ardor te
            despierta otra vez. Te sientas en el borde de la cama, respiras
            hondo intentando calmarte, pero el fuego en tu pecho no cede.
          </p>
          <p data-id="element-457">
            Vas a la cocina, tomas un antiácido masticable, bebes agua fría y
            esperas. Veinte minutos de alivio. Luego el fuego regresa.
          </p>
          <p data-id="element-458">
            Mañana estarás agotado, irritable, con la garganta rasposa y con esa
            niebla mental que te acompaña todo el día. Y lo peor: sabes que
            mañana por la noche volverá a ocurrir.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-459">
        <div className="bg-slate-900 border-l-4 border-red-500 p-6 sm:p-8 rounded-r-xl" data-id="element-460">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-461">
            Esto no es solo incómodo. Es peligroso.
          </h3>
          <p className="text-slate-300 mb-4" data-id="element-462">
            Cada noche que el ácido sube sin control, está quemando lentamente
            el tejido de tu esófago. Los médicos tienen un nombre para lo que
            ocurre después de años de reflujo no controlado:{' '}
            <strong className="text-red-400" data-id="element-463">Esófago de Barrett</strong>.
          </p>
          <p className="text-slate-300" data-id="element-464">
            Es una condición precancerosa. Y la mayoría de las personas que la
            desarrollan pensaron exactamente lo mismo que tú:{' '}
            <em className="text-slate-400" data-id="element-465">
              "Es solo acidez, ya se me pasará."
            </em>
          </p>
        </div>
      </FadeIn>
    </section>;
};